import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '@components/ui/Header';
import Footer from '@components/ui/Footer';
import PageHeader from './components/PageHeader';
import AppointmentForm from './components/AppointmentForm';

const AppointmentBookingLandingPage = () => {
  return (
    <>
      <Helmet>
        <title>Book an Appointment - EyeU Kenya | Professional Eye Care Services</title>
        <meta name="description" content="Schedule your eye care consultation with Kenya's leading ophthalmologists. Professional care, convenient online booking. Book your appointment today." />
        <meta name="keywords" content="eye care, ophthalmologist, appointment booking, Kenya, eye doctor, vision care, eye examination" />
        <meta property="og:title" content="Book an Appointment - EyeU Kenya" />
        <meta property="og:description" content="Schedule your eye care consultation with Kenya's leading ophthalmologists. Professional care, convenient online booking." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Book an Appointment - EyeU Kenya" />
        <meta name="twitter:description" content="Schedule your eye care consultation with Kenya's leading ophthalmologists." />
        <link rel="canonical" href="https://eyeukenya.com/appointment-booking-landing-page" />
      </Helmet>

      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        
        <main className="flex-1">
          <PageHeader />
          
          <section className="py-12 md:py-16">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <AppointmentForm />
            </div>
          </section>
        </main>

        <Footer />
        
      </div>
    </>
  );
};

export default AppointmentBookingLandingPage;